import { Button, Paper, Typography } from '@mui/material';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { playbackDateAtom } from 'atoms';
import dayjs from 'dayjs';

function WatchLiveButton() {
  const { t } = useTranslation('cameras');
  const [playbackDate, setPlaybackDate] = useRecoilState(playbackDateAtom);
  const [playbackDateCounted, setPlaybackDateCounted] = React.useState(dayjs(playbackDate));
  const timeout = useRef<NodeJS.Timeout | null>(null);

  const countTimeAdd = React.useCallback(() => {
    setPlaybackDateCounted(dayjs(playbackDateCounted).add(1, 'second'));
  }, [playbackDateCounted]);

  React.useEffect(
    function countTime() {
      timeout.current = setInterval(countTimeAdd, 1000);
      return () => {
        timeout.current && clearTimeout(timeout.current);
      };
    },
    [countTimeAdd, playbackDate],
  );

  return (
    <Paper
      sx={{
        position: 'absolute',
        top: '24px',
        left: '24px',
        color: 'white',
        bgcolor: 'rgba(48, 48, 48, 0.35)',
        px: 2,
        py: 1,
        textAlign: 'center',
      }}
    >
      <Typography sx={{ color: 'white', mb: 0.5 }}>{`${playbackDateCounted.format(
        'L',
      )} ${playbackDateCounted.format('LTS')}`}</Typography>
      <Button color="error" onClick={() => setPlaybackDate(null)}>
        {t('watch_live')}
      </Button>
    </Paper>
  );
}

export default WatchLiveButton;
